export default __webpack_public_path__ + "static/media/medical-records-hero.fa7e07a3.png";